import { IState, Country, State } from 'country-state-city';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { translations } from '../../../../../core/models/call-offer';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, takeUntil } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { PhoneNumberFormat } from 'ngx-intl-telephone-input';
import { ActivatedRoute, Router } from '@angular/router';
import {fileTypeExtention,serverError} from './../../../../../core/models/messages';
import { ToastMessage } from './../../../../../core/models/chapitreeval';
import { EsnclientService } from './../../../../../core/services/esnclient/esnclient.service';
import { linkedCompanyRegExp, patternEmail, urlRegExp } from './../../../../../core/models/pattern';
@Component({
  selector: 'app-add-client',
  templateUrl: './add-client.component.html',
  styleUrls: ['./add-client.component.css']
})
export class AddClientComponent {
  
 formclient: FormGroup = this.createclientForm();
SearchCountryField = SearchCountryField;
isDisabled = true;
clientSearchErrorMessage: string | null = null;
client_id: any;
isexistname = false;
id: any;
stateList: IState[] = [];
today = new Date();
countries: any = [];
mobilities: any[] = [];
currentDate!: string;
minDate!: string;
 separateDialCode: boolean = false;
CountryISO = CountryISO;

errorMessage: string = '';
errorMessageprofil: string = '';
preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom,
  ];
 PhoneNumberFormat = PhoneNumberFormat;
private unsubscribeAll: Subject<void> = new Subject();
 paysList: any[] = Country.getAllCountries().map((country) => ({
    ...country,
    name: this.translateCountryName(country.name),
  }));
  constructor(
    private formBuilder: FormBuilder,
    private clientservice: EsnclientService,
     private spinner: NgxSpinnerService,
     private toastrService: ToastrService,
      private router: Router,
  ) {
      const day = String(this.today.getDate()).padStart(2, "0");
    const month = String(this.today.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = this.today.getFullYear();
    this.currentDate = `${year}-${month}-${day}`;
    // Set the minimum date to 10 years ago, for example
    const minYear = 1990;
    this.minDate = `${minYear}-${month}-${day}`;
  }
   ngOnInit() {
    
   }
   
    createclientForm(data?: any) {
      return this.formBuilder.group({
        name: [data?.name || '', [Validators.required]],
        related_first_name_ESN: [data?.nom_vis_a_vis || null],
        related_last_name_ESN: [data?.prenom_vis_a_vis
          || null],
        related_email_ESN: [data?.email_vis_a_vis || null , [ Validators.required, Validators.email, Validators.pattern(patternEmail)]],
        country: [data?.country || null],
        city: [data?.city || null],
        related_phone_ESN: [data?.num_vis_a_vis || null],
        linkedin_link: [data ? data.linkedin_link : "", [Validators.pattern(linkedCompanyRegExp)]],
        website_link: [data ? data.website_link : "", [Validators.pattern(urlRegExp)]],
        year_of_creation:[data ? new Date(data.year_of_creation).getFullYear().toString() : ''],
        date_first_presentation: [data?.date_first_presentation || null],
        nb_days: [data?.nb_days || ''],
        client_id: this.id,
      });
    }

 getclientByName(event: any) {
    this.clientservice.getclientbyname(event.target.value).subscribe({
      next: (res) => {
        if (res.status === 200) {
          const citiesString = res.data.city ?? ''; 
          this.isexistname = true;
          this.client_id = res.data.uuid;
          this.formclient.patchValue({
            linkedin_link: res.data.linkedin_link,
            country: res.data.country,
            city: citiesString ? citiesString.split(',').map((v:any) =>v.trim()) : [],
            website_link: res.data.website_link,
            year_of_creation: res.data.year_of_creation? new Date(res.data.year_of_creation, 0) : null,
            domain: res.data.domain,
            type: res.data.type,
            fournisseur_id: res.data.uuid,
            ContactEmail: res.data.ContactEmail,
          });
          this.toggleFormFieldsUpdate(false)
        }
      },
      error: (error) => {       
        this.isexistname = false;
        this.formclient.patchValue({
          linkedin_link: "",
          country: null,
          city: null,
          website_link:  "",
          year_of_creation:  "",
          domain:  "",
          type:  "",
          fournisseur_id:  "",
          ContactEmail:  "",
        });
        this.toggleFormFieldsUpdate(true)
        if (
          error?.status === 400 &&
          error?.error?.message === 'client already associated to this company'
        ) {
          this.clientSearchErrorMessage = error?.error?.message;
        } else {
          this.clientSearchErrorMessage = '';
        }
      },
    });
  }

   translateCountryName(name: string): string {
    
      return translations[name] || name;
    }

   toggleFormFieldsUpdate(isEnabled: boolean): void {
      if (this.formclient) {
          const action = isEnabled ? 'enable' : 'disable';
          this.formclient.get('country')?.[action]();
          this.formclient.get('city')?.[action]();
          this.formclient.get('year_of_creation')?.[action]();
          this.formclient.get('linkedin_link')?.[action]();
          this.formclient.get('website_link')?.[action]();
      }
    }
      onCountryChange(event: any): void {
    if (event) {
      this.stateList = State.getStatesOfCountry(event.isoCode);
      for (const iterator of this.stateList) {
        iterator.name = iterator.name.replace(' Governorate', '');
      }
    } else {
      this.stateList = [];
      this.formclient.get('city')?.setValue(null);
    }
  }
// onCountryChange (mode: string): void {
//     this.formclient.get('city')?.enable();
//     this.countries = this.formclient.get('country')?.value;
//     this.countries = this.countries.map(
//       (item: any) => this.paysList.filter((it) => it.name === item)[0]
//     );
//     this.stateList.length = 0;
//     this.countries.forEach((item: any) => {
//   this.stateList.push(...State.getStatesOfCountry(item.isoCode));
// });
//     this.stateList = this.stateList.flat();
//     for (const iterator of this.stateList) {
//       iterator.name = iterator.name.replace(' Governorate', '');
//     }
//     this.stateList = this.stateList.map((item: any) => item.name);
//     this.mobilities = this.formclient.get('city')?.value;
//     if (this.mobilities != null && this.mobilities.length > 0) {
//       let differentItemsArray1: any[] = [];
//       differentItemsArray1 = this.mobilities.filter(
//         (item) => !this.stateList.includes(item)
//       );
//       const differentItemsArray2 = this.mobilities.filter(
//         (item) => !differentItemsArray1.includes(item)
//       );
//       this.formclient.get('city')?.setValue(differentItemsArray2);
//     }
//     // }
//     if (this.stateList.length == 0) {
//       this.stateList = [];
//       mode == 'add';
//       this.formclient.get('city')?.setValue(null);
//     }
//   }

  onMobilityChange(mode: string) {
    this.mobilities = this.formclient.get('city')?.value;
    let paysLists: any[] = [];
    this.countries = this.formclient.get('country')?.value;
    this.countries = this.countries?.filter(async (item: any) => {
      paysLists.push(this.paysList.filter((it) => it.name === item)[0]);
    });
    let stateListAfter1: any[] = [];
    paysLists.forEach((item) => {
      let stateListAfter: any[] = [];
      stateListAfter = State.getStatesOfCountry(item.isoCode);
      let difference1: any[] = [];
      if (this.countries.length > 0) {
        difference1 = this.findDuplicates(
          this.mobilities,
          stateListAfter.map((item) => item.name)
        );
        if (difference1.length == 0) {
          let index = this.countries.indexOf(item.name);
          if (index !== -1) {
            let new_array = this.countries
              .slice(0, index)
              .concat(this.countries.slice(index + 1));
            this.stateList = this.stateList.filter(
              (item: any) =>
                !stateListAfter.map((item) => item.name).includes(item)
            );
          }
        }
      }
    });
    //  this.stateList=stateListAfter1

    this.mobilities = this.formclient.get('city')?.value;
    if (this.mobilities.length === 0 || this.stateList.length === 0) {
      this.formclient.get('city')?.disable();
      mode == 'add';
      this.formclient.get('country')?.setValue(null);
      mode == 'add';
      this.formclient.get('city')?.setValue(null);
      this.formclient.get('country')!.updateValueAndValidity();
      this.formclient.get('city')!.updateValueAndValidity();
      this.stateList.length = 0;
    }
  }
findDuplicates(array1: any, array2: any) {
    let occurrences: any[] = [];
    let duplicates: any = [];
    for (let element of array1) {
      occurrences[element] = (occurrences[element] || 0) + 1;
    }
    for (let element of array2) {
      if (occurrences[element] && !duplicates.includes(element)) {
        duplicates.push(element);
      }
    }

    return duplicates;
  }
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    // Retirer tout caractère qui n'est pas un chiffre, un slash ou un espace
    input.value = input.value.replace(/[^0-9\/]/g, '');
  }
  toastMessages: ToastMessage = {
      success: 'Client ajouté avec succès',
      error: 'Client avec ce nom existe déjà',
    };
 createClient() {
    this.spinner.show();
    // Récupérer l'année de la date directement depuis le formulaire
    let date: any = new Date(this.formclient.get('year_of_creation')?.value);
    let yearOfCreation = date?.getFullYear();
    console.log('date', yearOfCreation)
    if (!this.isexistname) {
      this.setValidatorRequirements();
      this.formclient
        .get('related_phone_ESN')
        ?.setValue(this.formclient.get('related_phone_ESN')?.value?.internationalNumber);

        this.formclient
        .get('year_of_creation')
        ?.setValue(yearOfCreation);

        this.formclient
        .get('country')
        ?.setValue(this.formclient.value.country);
  
      // this.formclient.patchValue({
      //   year_of_creation: yearOfCreation 
      // });
  
      this.clientservice
        .createclient(this.formclient.value)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.spinner.hide();
            this.toastrService.success(this.toastMessages.success);
            this.router.navigate([`/nos-clients/liste`]);
          },
          error: (err) => {
            this.spinner.hide();
               console.log(err.error.message.related_email_ESN);
               console.log(err.error.message.linkedin_link);
               if(err.error.message.linkedin_link) {
                this.toastrService.error('Le lien linkedin_link a déjà été pris.');
               }
               else if(err.error.message.related_email_ESN) {
                this.toastrService.error('"La valeur du champ related email e s n est déjà utilisée."');
               }else {
                this.toastrService.error(serverError);
              }
            if (err?.error) {
              if (err.error.message['name']) {
                this.toastrService.error(this.toastMessages.error);
              } 
            }
          },
        });
    } else {  
      let data = {
        client_id: this.client_id,
        related_first_name_ESN: this.formclient.value.related_first_name_ESN,
        related_email_ESN: this.formclient.value.related_email_ESN,
        related_last_name_ESN: this.formclient.value.related_last_name_ESN,
        related_phone_ESN: this.formclient.value?.related_phone_ESN?.number,
        date_first_presentation: this.formclient.value.date_first_presentation,
        nb_days: this.formclient.value.nb_days,
        year_of_creation: yearOfCreation // Ajouter l'année dans les données
      };
  
      this.clientservice
        .createclient(data)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.spinner.hide();
            this.toastrService.success(this.toastMessages.success);
            this.router.navigate([`/nos-clients/liste`]);
            // this.formclient.reset();
          },
          error: (err) => {
            this.spinner.hide();
            if (err?.error) {
              if (err.error.message['name']) {
                this.toastrService.error(this.toastMessages.error);
              } else {
                this.toastrService.error(serverError);
              }
            }
          },
        });
    }

  }

   atLeastOneFieldRequired(formclient: FormGroup) {
    const linkedin = formclient.get('linkedin_link')?.value;
    const website = formclient.get('website_link')?.value;
    return linkedin || website ? null : { atLeastOneRequired: true };
  }
  showAtLeastOneFieldError(): boolean {
  const group = this.formclient;
  return group.hasError('atLeastOneRequired') || 
         (!group.get('linkedin_link')?.value && !group.get('website_link')?.value);
}
    setValidatorRequirements() {
        if (
          !this.formclient.get('linkedin_link')?.value ||
          this.formclient.get('linkedin_link')?.value == ''
        ) {
          this.formclient
            .get('website_link')
            ?.setValidators([Validators.required, Validators.pattern(urlRegExp)]);
          this.formclient.get('website_link')!.updateValueAndValidity();
          this.formclient.get('linkedin_link')?.clearValidators();
          this.formclient.get('linkedin_link')?.updateValueAndValidity();
        }
        if (this.formclient.get('website_link')?.value == '') {
          this.formclient
            .get('linkedin_link')
            ?.setValidators([
              Validators.required,
              Validators.pattern(linkedCompanyRegExp),
            ]);
          this.formclient.get('linkedin_link')!.updateValueAndValidity();
          this.formclient.get('website_link')?.clearValidators();
          this.formclient
            .get('website_link')
            ?.setValidators(Validators.pattern(urlRegExp));
          this.formclient.get('website_link')?.updateValueAndValidity();
        }
  }
}
